import React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';

import { CUSTOMER_DETAILS } from '../../steps';
import Button from '../button';
import { Select } from '../tracking-text-input';
import Field from '../field';
import fetchGroup from '../../actions/fetch-group';

export default function({ onConfirm = () => {} }) {
  const dispatch = Redux.useDispatch();
  const {
    group: { slug, loading },
    pageText: {
      continueButton,
      customerDetails: { selectType },
    },
  } = Redux.useSelector(state => state);
  const [newGroupSlug, setNewGroupSlug] = React.useState(slug);

  React.useEffect(() => {
    if (slug !== newGroupSlug) {
      dispatch(fetchGroup(newGroupSlug));
    }
  }, [dispatch, slug, newGroupSlug]);

  return (
    <Wrapper>
      <h4>{selectType.tmoForBusinessText}</h4>

      <Field label="">
        <Select
          name="customer-type"
          onChange={value => setNewGroupSlug(value)}
          options={[
            {
              label: selectType.nonProtected,
              value: '4910cbdf-91c2-f131-0991-311276247f79',
            },
            {
              label: selectType.tfbRepair,
              value: 'e5bd266d-6ec1-4750-9dc4-ee49482ce27f',
            },
          ]}
          searchable={false}
          step={'TMO-FOR-BUSINESS'}
          value={slug}
        />
      </Field>
      <Button
        disabled={loading}
        name="Continue (tmo for business)"
        onClick={onConfirm}
        step={CUSTOMER_DETAILS}
      >
        {continueButton}
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  h4 {
    font-weight: 300;
    margin: 0;
  }
`;
